/**
 * formatMentionsInMessage function modifies the input messages according to the instructions
 *
 * getMentionsList is a parameter which is a function that returns an array of objects
 * allMentions is an array of usernames extracted from getMentionsList function
 * escapedNames is same as allMentions but it makes sure that if any name contains special
 * characters, they work properly
 * nameRegex is a username list string separated by | extracted from escapedNames
 * currentChatMessage is the text entered in the textbox which includes all the mentioned names
 * updatedMessage matches all the names from the nameRegex and replaces them with each name
 * enclosed with parenthesis preceded by @
 * Ex: "Hello @John Doe" will be converted to "Hello @(John Doe)"
 *
 * Result: Later in the view, this "Hello @(John Doe)" will be shown as
 * "Hello <span class="chat-message__mention">@John Doe</span>" and "@John Doe" will have our desired styles
 */

import getMentionsList from './getMentionsList';

const escapeRegExp = str => str.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');

const formatMentionsInMessage = (message, roomUsers, currentUserId, laymanMode) => {
  const mentionNames = getMentionsList(roomUsers, currentUserId, laymanMode).map(user =>
    escapeRegExp(user.display),
  );

  if (mentionNames.length === 0) return message;

  const mentionPattern = new RegExp(`@(${mentionNames.join('|')})\\b`, 'g');

  return message.replace(mentionPattern, (_, name) => `@(${name} )`);
};

export default formatMentionsInMessage;
